/// <amd-module name="Reporting/BurndownReport/BurndownReportTeachingBubbleHelper" />
import { LightboxReportGuidedTourUtilityProps } from "Reporting/BoardsCommon/LightboxReportGuidedTourUtility";
import { ReportGuidedTourUtilityProps } from "Reporting/BoardsCommon/ReportGuidedTourUtility";
import * as Resources from "Reporting/BurndownReport/Resources";
import { getBurndownReportSettingsStorageKey } from "./BurndownReportUserSettings";

export function getReportTeachingBubblesData(): ReportGuidedTourUtilityProps {
    return {
        reportKey: getBurndownReportSettingsStorageKey(),
        tourBubble: {
            title: Resources.TourBubbleTitle,
            text: Resources.TourBubbleText
        },
        filterBubble: {
            title: Resources.FilterBubbleTitle,
            text: Resources.FilterBubbleText
        },
        chartBubble: {
            title: Resources.ChartBubbleTitle,
            text: Resources.ChartBubbleText
        },
        legendBubble: {
            title: Resources.LegendBubbleTitle,
            text: Resources.LegendBubbleText
        },
        reportDocumentationUrl: "https://go.microsoft.com/fwlink/?linkid=2096311"
    };
}

export function getLightboxTeachingBubblesData(): LightboxReportGuidedTourUtilityProps {
    return {
        reportKey: getBurndownReportSettingsStorageKey(),
        tourBubble: {
            title: Resources.LightboxTourBubbleTitle,
            text: Resources.LightboxTourBubbleText
        }
    };
}
